import { defineMessages } from 'react-intl';

export const labels = defineMessages({
  needsAuthorizationTitle: {
    defaultMessage: 'Export/Archive - AP Schedule',
    description: 'Title for export/archive dialog in AP Schedule page'
  },
  tableTitle: {
    description: 'Table header title for AP Schedule page',
    defaultMessage: 'Vendors'
  }
});

export const tableHeaders = defineMessages({
  vendorNo: {
    description: 'Table header for vendor no',
    defaultMessage: 'Vendor No.'
  },
  vendorName: {
    description: 'Table header for vendor name',
    defaultMessage: 'Vendor Name'
  },
  paymentMethod: {
    description: 'Table header for payment method',
    defaultMessage: 'Payment Method'
  },
  totalDue: {
    description: 'Table header for total due',
    defaultMessage: 'Total Due ($)'
  },
  discount: {
    description: 'Table header for discount amount',
    defaultMessage: 'Discount ($)'
  },
  netDue: {
    description: 'Table header for net due',
    defaultMessage: 'Net Due ($)'
  },
  invoiceNo: {
    description: 'Table header for invoice no',
    defaultMessage: 'Invoice No.'
  },
  dueDate: {
    description: 'Table header for due date',
    defaultMessage: 'Due Date'
  },
  netPayment: {
    description: 'Table header for net payment',
    defaultMessage: 'Net Pmt ($)'
  },
  status: {
    description: 'Table header for status',
    defaultMessage: 'Status'
  }
});

export const errors = defineMessages({
  errorMessage: {
    description: 'Vendor Invoices not selected error message',
    defaultMessage:
      'First, select the vendor invoices you would like to authorize.'
  }
});
